import { Component, Vue, Emit, Prop } from 'vue-property-decorator';
import { TenantDetailsApi } from '@/common/models';
import InviteUserModal from './userInvite';
import { UsersFormDataTenantUserInvite } from '@/common/viewModels/users/form/data/UsersFormDataTenantUserInvite';
import { UsersFormStateTenantUserInvite } from '@/common/viewModels/users/form/state/UsersFormStateTenantUserInvite';
import { Button } from '@/external/telstra-ui-vue/components';
import SelfInviteConfirmModal from './selfInvite';

@Component({
  components: {
    InviteUserModal,
    SelfInviteConfirmModal,
    Button,
  },
})

export default class UsersHeader extends Vue {
  @Prop({ required: true }) tenantDetails!: TenantDetailsApi;
  @Prop({ required: true }) tenantUserInviteFormData!: UsersFormDataTenantUserInvite;
  @Prop({ required: true }) tenantUserInviteFormState!: UsersFormStateTenantUserInvite;
  @Prop({ required: true }) tenantUserInviteError!: string;
  @Prop({ default: true }) disableActionBtn!: boolean;
  @Prop({ required: true }) isSelfInviteEnabled!: boolean;

  @Emit()
  goBack(): void {
    this.$emit('goBack');
  }

  selfInviteConfirmed(): void {
    this.$emit('selfInvite');
  }
  
  inviteUserClicked(): void {
    (this.$refs.modalInviteUser as InviteUserModal).showModal();
  }

  hideSelfInviteConfirmModal(): void {
    (this.$refs.modalSelfInviteConfirm as SelfInviteConfirmModal).hideModal();
  }

  selfInviteClicked() {
    (this.$refs.modalSelfInviteConfirm as SelfInviteConfirmModal).showModal();
  }

  hideInviteUserModal(): void {
    (this.$refs.modalInviteUser as InviteUserModal).hideModal();
  }

  onInviteUserFormInputChange(fieldName: string, value: any) {
    this.$emit('inviteUserFormInputChange', fieldName, value);
  }

  onInviteUserToTenancy(): void {
    this.$emit('inviteUserToTenancy');
  }

  onResetInviteUserForm(): void {
    this.$emit('resetInviteUserForm');
  }
}
